import { render, staticRenderFns } from "./report_year.vue?vue&type=template&id=0f16b4fd&scoped=true"
import script from "./report_year.vue?vue&type=script&lang=js"
export * from "./report_year.vue?vue&type=script&lang=js"
import style0 from "./report_year.vue?vue&type=style&index=0&id=0f16b4fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f16b4fd",
  null
  
)

export default component.exports